import html2canvas from "html2canvas-pro";
import { jsPDF } from "jspdf";

/**
 * Render a DOM element as it is displayed into a paginated A3 PDF.
 * `filename` defaults to the inventory scan report name for its original caller.
 */
export async function exportReportToPdf(
  element: HTMLElement,
  filename = `inventory-scan-report-${new Date().toISOString().split("T")[0]}.pdf`
): Promise<void> {
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    logging: false,
    backgroundColor: "#ffffff",
    onclone: (_doc, clonedEl) => {
      const btn = clonedEl.querySelector<HTMLElement>("[data-export-button]");
      if (btn) btn.style.display = "none";
      clonedEl
        .querySelectorAll<HTMLElement>("[data-export-csv-button]")
        .forEach((el) => (el.style.display = "none"));
    },
  });

  const imgWidth = canvas.width;
  const imgHeight = canvas.height;

  const pdfWidth = 297;
  const pdfHeight = 420;
  const margin = 10;

  const contentWidth = pdfWidth - margin * 2;
  const scaledHeight = (imgHeight * contentWidth) / imgWidth;

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a3",
  });

  let yOffset = 0;
  const pageContentHeight = pdfHeight - margin * 2;

  while (yOffset < scaledHeight) {
    if (yOffset > 0) {
      pdf.addPage();
    }

    const sourceY = (yOffset / scaledHeight) * imgHeight;
    const sourceHeight = Math.min(
      (pageContentHeight / scaledHeight) * imgHeight,
      imgHeight - sourceY
    );
    const destHeight = (sourceHeight / imgHeight) * scaledHeight;

    const pageCanvas = document.createElement("canvas");
    pageCanvas.width = imgWidth;
    pageCanvas.height = sourceHeight;
    const ctx = pageCanvas.getContext("2d");
    if (ctx) {
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, imgWidth, sourceHeight);
      ctx.drawImage(canvas, 0, sourceY, imgWidth, sourceHeight, 0, 0, imgWidth, sourceHeight);
    }

    const pageImgData = pageCanvas.toDataURL("image/jpeg", 0.95);
    pdf.addImage(pageImgData, "JPEG", margin, margin, contentWidth, destHeight);

    yOffset += pageContentHeight;
  }

  pdf.save(filename);
}
